import { TFunction } from 'next-i18next';
import * as Yup from 'yup';

export class CreateAccountForm {
  public email: string;
  public username: string;
  public password: string;
  public confirm: string;
  public company: string | undefined;
  public firstName: string;
  public lastName: string;
  public address: string;
  public city: string;
  public state: string;
  public zipCode: string;
  public phone: string;
  public isAgree: boolean;

  constructor() {
    this.email = '';
    this.username = '';
    this.password = '';
    this.confirm = '';
    this.company = '';
    this.firstName = '';
    this.lastName = '';
    this.address = '';
    this.city = '';
    this.state = '';
    this.zipCode = '';
    this.phone = '';
    this.isAgree = false;
  }

  public static getValidationSchema(t: TFunction): Yup.SchemaOf<CreateAccountForm> {
    return Yup.object()
      .shape({
        email: Yup.string()
          .required(t('ERRORS.TEXT_EMAIL_REQUIRED'))
          .email(t('ERRORS.TEXT_EMAIL_INVALID')),
        username: Yup.string()
          .required(t('ERRORS.TEXT_USERNAME_REQUIRED')),
        password: Yup.string()
          .required(t('ERRORS.TEXT_PASSWORD_REQUIRED')),
        confirm: Yup.string()
          .required(t('ERRORS.TEXT_CONFIRM_PASSWORD_REQUIRED'))
          .oneOf([Yup.ref('password')], t('ERRORS.TEXT_CONFIRM_PASSWORD_MAST_MATH')),
        company: Yup.string(),
        firstName: Yup.string()
          .required(t('ERRORS.TEXT_FIRST_NAME_REQUIRED')),
        lastName: Yup.string()
          .required(t('ERRORS.TEXT_LAST_NAME_REQUIRED')),
        address: Yup.string()
          .required(t('ERRORS.TEXT_ADDRESS_REQUIRED')),
        city: Yup.string()
          .required(t('ERRORS.TEXT_CITY_REQUIRED')),
        state: Yup.string()
          .required(t('ERRORS.TEXT_STATE_REQUIRED')),
        zipCode: Yup.string()
          .matches(/^\d{5,5}-?[\dA-Z]{0,4}$/, t('ERRORS.TEXT_ZIP_CODE_INVALID'))
          .required(t('ERRORS.TEXT_ZIP_CODE_REQUIRED')),
        phone: Yup.string()
          .length(12, t('ERRORS.TEXT_PHONE_INVALID'))
          .required(t('ERRORS.TEXT_PHONE_REQUIRED')),
        isAgree: Yup.boolean()
          .required()
          .oneOf([true], t('ERRORS.TEXT_MAST_BE_AGREE'))
          .isTrue(t('ERRORS.TEXT_MAST_BE_AGREE'))
      });
  }
}
